export const setLocalStorageItem = (name: string, value: any) => {
  localStorage.setItem(name, JSON.stringify(value));
};

export const getLocalStorageItem = (name: string) => {
  const textValue = localStorage.getItem(name);

  try {
    return JSON.parse(textValue || '');
  } catch (_e) {
    return null;
  }
};
